// 依据 iview 的inputNumber 魔改prop而来的。新增参数如下：
// controls: 是否展示控制器
// formatMethod：预置了几个展示值处理方法:  thousands 千分位+精度值处理 精度值处理依赖原精度参数
//                                        percentage  百分比处理
//                                        default  无处理，为了无控制器，放在需要数字输入的地方，例如电话号码
//  默认值 default
<template>
  <div :class="wrapClasses">
    <div :class="handlerClasses" v-if="!controlsOutside && controls">
      <a :class="upClasses" @click="up">
        <span :class="innerUpClasses" @click="preventDefault"></span>
      </a>
      <a :class="downClasses" @click="down">
        <span :class="innerDownClasses" @click="preventDefault"></span>
      </a>
    </div>
    <div :class="{ 'ivu-input-number-controls-outside-btn-disabled': downDisabled, }" @click="down"
         class="ivu-input-number-controls-outside-btn ivu-input-number-controls-outside-down"
         v-if="controlsOutside && controls">
      <i class="ivu-icon ivu-icon-ios-remove"></i>
    </div>
    <div :class="{ 'ivu-input-number-controls-outside-btn-disabled': upDisabled }" @click="up"
         class="ivu-input-number-controls-outside-btn ivu-input-number-controls-outside-up" v-if="controlsOutside">
      <i class="ivu-icon ivu-icon-ios-add"></i>
    </div>
    <div :class="inputWrapClasses" class="flex">
      <input :autofocus="autofocus" :class="inputClasses" :disabled="itemDisabled" :id="elementId" :name="name"
             :placeholder="placeholder" :readonly="readonly || !editable" :value="formatterValue" @blur="blur"
             @change="change" @focus="focus" @input="change" @keydown.stop="keyDown" @mouseup="preventDefault"
             autocomplete="off" spellcheck="false"/>
      <div>
        <slot name="append"></slot>
      </div>
    </div>
  </div>
</template>
<script>
import {findComponentUpward, oneOf} from 'view-design/src/utils/assist'
import Emitter from 'view-design/src/mixins/emitter'
import mixinsForm from 'view-design/src/mixins/form'

const prefixCls = 'ivu-input-number'
const iconPrefixCls = 'ivu-icon'

function addNum (num1, num2) {
  let sq1, sq2, m
  try {
    sq1 = num1.toString().split('.')[1].length
  } catch (e) {
    sq1 = 0
  }
  try {
    sq2 = num2.toString().split('.')[1].length
  } catch (e) {
    sq2 = 0
  }

  m = Math.pow(10, Math.max(sq1, sq2))
  return (Math.round(num1 * m) + Math.round(num2 * m)) / m
}

export default {
  name: 'inputNumber',
  mixins: [Emitter, mixinsForm],
  props: {
    max: {
      type: Number,
      default: Infinity,
    },
    min: {
      type: Number,
      default: -Infinity,
    },
    step: {
      type: Number,
      default: 1,
    },
    activeChange: {
      type: Boolean,
      default: true,
    },
    value: {},
    size: {
      validator (value) {
        return oneOf(value, ['small', 'large', 'default'])
      },
      default () {
        return !this.$IVIEW || this.$IVIEW.size === ''
          ? 'default'
          : this.$IVIEW.size
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    name: {
      type: String,
    },
    precision: {
      type: Number,
    },
    elementId: {
      type: String,
    },
    formatter: {
      type: Function,
    },
    parser: {
      type: Function,
    },
    placeholder: {
      type: String,
      default: '',
    },
    // 4.5.0
    controlsOutside: {
      type: Boolean,
      default: false,
    },
    controls: {
      type: Boolean,
      default: false,
    },
    formatMethod: {
      type: String,
      default: 'default',
    },
  },
  data () {
    return {
      focused: false,
      upDisabled: false,
      downDisabled: false,
      currentValue: this.value ? Number(this.value) : '',
    }
  },
  computed: {
    wrapClasses () {
      return [
        `${prefixCls}`,
        {
          [`${prefixCls}-${this.size}`]: !!this.size,
          [`${prefixCls}-disabled`]: this.itemDisabled,
          [`${prefixCls}-focused`]: this.focused,
          [`${prefixCls}-controls-outside`]: this.controlsOutside,
        },
      ]
    },
    handlerClasses () {
      return `${prefixCls}-handler-wrap`
    },
    upClasses () {
      return [
        `${prefixCls}-handler`,
        `${prefixCls}-handler-up`,
        {
          [`${prefixCls}-handler-up-disabled`]: this.upDisabled,
        },
      ]
    },
    innerUpClasses () {
      return `${prefixCls}-handler-up-inner ${iconPrefixCls} ${iconPrefixCls}-ios-arrow-up`
    },
    downClasses () {
      return [
        `${prefixCls}-handler`,
        `${prefixCls}-handler-down`,
        {
          [`${prefixCls}-handler-down-disabled`]: this.downDisabled,
        },
      ]
    },
    innerDownClasses () {
      return `${prefixCls}-handler-down-inner ${iconPrefixCls} ${iconPrefixCls}-ios-arrow-down`
    },
    inputWrapClasses () {
      return `${prefixCls}-input-wrap`
    },
    inputClasses () {
      return `${prefixCls}-input`
    },
    precisionValue () {
      // can not display 1.0
      if (typeof this.currentValue !== 'number') return this.currentValue
      return this.precision
        ? this.currentValue.toFixed(this.precision)
        : this.currentValue
    },
    formatterValue () {
      if (this.focused) {
        return this.currentValue
      }
      if (
        this.currentValue != null &&
        typeof Number(this.currentValue === 'number')
      ) {
        if (this.formatMethod === 'percentage') {
          const currentValues = this.currentValue.toString()
          if (currentValues.indexOf('%') !== -1) {
            const a = Number(currentValues.replace('%', ''))
            return new Decimal(a).mul(new Decimal(100).toNumber()) + '%'
          } else if (typeof Number(this.currentValue) === 'number') {
            return (
              new Decimal(Number(this.currentValue)).mul(
                new Decimal(100).toNumber()
              ) + '%'
            )
          } else {
            return this.currentValue
          }
        } else if (this.formatMethod === 'thousands') {
          return this.$thousands(Number(this.currentValue), this.precision)
        } else if (this.formatMethod === 'default') {
          return this.currentValue
        } else if (this.formatMethod === 'phone') {
          let accountName = ''
          if (this.currentValue) {
            let text = this.currentValue + ''
            if (text.replace(/-/g, '').length < 3) {
              accountName = text.replace(/-/g, '')
            } else if (text.replace(/-/g, '').length >= 3 && text.replace(/-/g, '').length < 7) {
              accountName = text.replace(/-/g, '').replace(/(\d{3})/, '$1-')
            } else if (text.replace(/-/g, '').length >= 7) {
              accountName = text.replace(/-/g, '').replace(/(\d{3})(\d{4})/, '$1-$2-')
            }
          } else {
            accountName = accountName.trim()
          }
          return accountName
        } else {
          return this.currentValue
        }
      }
    },
  },
  methods: {
    preventDefault (e) {
      e.preventDefault()
    },
    up (e) {
      const targetVal = Number(e.target.value)
      if (this.upDisabled && isNaN(targetVal)) {
        return false
      }
      this.changeStep('up', e)
    },
    down (e) {
      const targetVal = Number(e.target.value)
      if (this.downDisabled && isNaN(targetVal)) {
        return false
      }
      this.changeStep('down', e)
    },
    changeStep (type, e) {
      if (this.itemDisabled || this.readonly) {
        return false
      }

      const targetVal = Number(e.target.value)
      let val = Number(this.currentValue)
      const step = Number(this.step)
      if (isNaN(val)) {
        return false
      }

      // input a number, and key up or down
      if (!isNaN(targetVal)) {
        if (type === 'up') {
          if (addNum(targetVal, step) <= this.max) {
            val = targetVal
          } else {
            return false
          }
        } else if (type === 'down') {
          if (addNum(targetVal, -step) >= this.min) {
            val = targetVal
          } else {
            return false
          }
        }
      }

      if (type === 'up') {
        val = addNum(val, step)
      } else if (type === 'down') {
        val = addNum(val, -step)
      }
      this.setValue(val)
    },
    setValue (val) {
      // 如果 step 是小数，且没有设置 precision，是有问题的
      if (val && !isNaN(this.precision))
        val = Number(Number(val).toFixed(this.precision))

      const {min, max} = this
      if (val !== null) {
        if (val > max) {
          val = max
        } else if (val < min) {
          val = min
        }
      }

      this.$nextTick(() => {
        this.currentValue = val
        this.$emit('input', val)
        this.$emit('on-change', val)
        this.dispatch('FormItem', 'on-form-change', val)
      })
    },
    focus (event) {
      this.focused = true
      this.$emit('on-focus', event)
    },
    blur () {
      this.focused = false
      this.$emit('on-blur')
      if (
        !findComponentUpward(this, [
          'DatePicker',
          'TimePicker',
          'Cascader',
          'Search',
        ])
      ) {
        this.dispatch('FormItem', 'on-form-blur', this.currentValue)
      }
    },
    keyDown (e) {
      if (e.keyCode === 38) {
        e.preventDefault()
        this.up(e)
      } else if (e.keyCode === 40) {
        e.preventDefault()
        this.down(e)
      }
    },
    change (event) {
      if (event.type == 'change' && this.activeChange) return

      if (event.type == 'input' && !this.activeChange) return
      let val = event.target.value.trim()
      if (this.parser) {
        val = this.parser(val)
      }

      const isEmptyString = val.length === 0
      if (isEmptyString) {
        this.setValue(null)
        return
      }
      if (event.type == 'input' && val.match(/^\-?\.?$|\.$/)) return // prevent fire early if decimal. If no more input the change event will fire later

      val = Number(val)

      if (!isNaN(val)) {
        this.currentValue = val
        this.setValue(val)
      } else {
        event.target.value = this.currentValue
      }
    },
    changeVal (val) {
      val = Number(val)
      if (!isNaN(val)) {
        const step = this.step

        this.upDisabled = val + step > this.max
        this.downDisabled = val - step < this.min
      } else {
        this.upDisabled = true
        this.downDisabled = true
      }
    },
  },
  mounted () {
    this.changeVal(this.currentValue)
  },
  watch: {
    value (val) {
      this.currentValue = val
    },
    currentValue (val) {
      this.changeVal(val)
    },
    min () {
      this.changeVal(this.currentValue)
    },
    max () {
      this.changeVal(this.currentValue)
    },
  },
}
</script>
<style lang="scss" scoped>
  .ivu-input-number {
    width: 100%;
  }
</style>
